import {showError} from "./exceptionUtils";
import { playScanFailedAoSound } from "./scanUtils";
import { t } from '../i18n';

const BAG_NUMBER_PREFIX = 'BAG';
const TT_BAG_NUMBER_PREFIX = 'TT';
const TRACKING_NUMBER_PREFIX = 'SWX';
// Temu PPMOD SCF 大箱条码前缀：回告成功后 Temu 返回 uspsContainerCode 存到 bag.external_bag_number；
// 与后端 BarCodeUtil.PPMOD_99M_BAG_NUMBER_PREFIX 保持一致
const PPMOD_99M_BAG_NUMBER_PREFIX = '99M';

const BAG_NUMBER_LENGTH = 16;
const TRACKING_NUMBER_LENGTH = 21;
const TT_BAG_NUMBER_LENGTH = 20;

export const isBagNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    return barCode.startsWith(BAG_NUMBER_PREFIX) && barCode.length === BAG_NUMBER_LENGTH;
};

/**
 * TT 包牌：以 TT 开头（如 TTLAX1ATL…），或 20 位且非 BAG 前缀（不带 BAG 的 TT 号格式）。
 */
export const isTtBagNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    const trimmed = barCode.trim();
    if (trimmed.toUpperCase().startsWith(TT_BAG_NUMBER_PREFIX)) {
        return true;
    }
    return !trimmed.startsWith(BAG_NUMBER_PREFIX) && trimmed.length === TT_BAG_NUMBER_LENGTH;
};

/**
 * Temu PPMOD 大箱条码（99M 开头）。回告成功后由 Temu 返回并落到 bag.external_bag_number，
 * 装车/发件扫码时业务侧当作包牌处理，与后端 BarCodeUtil.isPpmod99MBagNumber 语义对齐。
 */
export const isPpmod99MBagNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    return barCode.trim().startsWith(PPMOD_99M_BAG_NUMBER_PREFIX);
};

export const isTrackingNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    if(barCode.startsWith(TRACKING_NUMBER_PREFIX))
        return barCode.length === TRACKING_NUMBER_LENGTH;
    else 
        return true;
};

export const isValidBarCode = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    if(barCode.startsWith(BAG_NUMBER_PREFIX))
        return isBagNumber(barCode);
    else 
        return isTrackingNumber(barCode);
};

export const showBarCodeError = async (barCode: string) => {
    if (barCode.length === 0) {
        return;
    }
    await playScanFailedAoSound();
    showError({
        title: t('pda.errors.invalidBarCode.title'),
        message: t('pda.errors.invalidBarCode.message', { barCode }),
    });
};

export const showTrackingNumberError = async (barCode: string) => {
    if (barCode.length === 0) {
        return;
    }
    await playScanFailedAoSound();
    showError({
        title: t('pda.errors.invalidTrackingNumber.title'),
        message: t('pda.errors.invalidTrackingNumber.message', { barCode }),
    });
};

export const showBagNumberError = async (barCode: string) => {
    if (barCode.length === 0) {
        return;
    }
    await playScanFailedAoSound();
    showError({
        title: t('pda.errors.invalidBagNumber.title'),
        message: t('pda.errors.invalidBagNumber.message', { barCode }),
    });
};